var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotivation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 172,
    viewBox: "0 0 139 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_402_592)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.249,
    y: 32.8902,
    width: 89.751,
    height: 106.069,
    rx: 4.89551,
    fill: "url(#paint0_linear_402_592)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_402_592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5248 125.343L55.3825 125.606L55.531 125.355V132.3L55.3825 132.094L56.5248 132.334V132.825H53.6805V132.334L54.8457 132.094L54.6629 132.3V125.892L54.8114 125.903L52.2184 130.746L51.5902 130.792L49.0771 125.88L49.2142 125.869V132.3L49.0771 132.106L50.208 132.334V132.825H47.4551V132.334L48.5974 132.094L48.4374 132.3V125.355L48.5974 125.606L47.4551 125.4V124.909L49.5912 124.852L52.0699 129.867H51.9328L54.4916 124.909L56.5248 124.852V125.343Z",
    fill: "url(#paint1_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2375 126.691C61.0752 126.691 61.7301 126.954 62.2022 127.479C62.682 128.005 62.9219 128.747 62.9219 129.707C62.9219 130.354 62.8039 130.921 62.5678 131.409C62.3393 131.889 62.0119 132.262 61.5854 132.528C61.159 132.795 60.6449 132.928 60.0433 132.928C59.2209 132.928 58.5774 132.673 58.1129 132.163C57.6483 131.645 57.4161 130.902 57.4161 129.935C57.4161 129.265 57.5265 128.69 57.7473 128.21C57.9758 127.723 58.2994 127.35 58.7183 127.091C59.1447 126.824 59.6511 126.691 60.2375 126.691ZM60.1918 127.365C59.6055 127.365 59.1562 127.586 58.8439 128.028C58.5317 128.469 58.3756 129.09 58.3756 129.89C58.3756 130.674 58.5241 131.264 58.8211 131.66C59.1181 132.056 59.5445 132.254 60.1004 132.254C60.504 132.254 60.8429 132.155 61.1171 131.957C61.3988 131.751 61.6083 131.462 61.7453 131.089C61.89 130.716 61.9624 130.27 61.9624 129.752C61.9624 128.976 61.8063 128.386 61.494 127.982C61.1894 127.571 60.7554 127.365 60.1918 127.365Z",
    fill: "url(#paint2_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9055 132.928C65.5095 132.928 65.1973 132.806 64.9688 132.562C64.7404 132.311 64.6261 131.934 64.6261 131.432V127.285L64.7746 127.434H63.5981V126.931L64.786 126.76L64.6261 126.942V125.435L65.5399 125.286V126.942L65.4143 126.794H67.2077L67.1734 127.434H65.4143L65.5399 127.285V131.306C65.5399 131.626 65.6009 131.858 65.7227 132.003C65.8522 132.147 66.0311 132.22 66.2596 132.22C66.3967 132.22 66.5452 132.197 66.7051 132.151C66.865 132.106 67.0363 132.041 67.2191 131.957L67.4133 132.483C66.8726 132.78 66.37 132.928 65.9055 132.928Z",
    fill: "url(#paint3_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.827 132.243L69.7242 132.117L70.718 132.334V132.825H68.0222V132.334L69.016 132.117L68.9132 132.243V127.422L69.0046 127.525L68.0222 127.319V126.828L69.827 126.76V132.243ZM69.3015 125.526C69.1264 125.526 68.9817 125.469 68.8675 125.355C68.7532 125.24 68.6961 125.084 68.6961 124.886C68.6961 124.681 68.7532 124.525 68.8675 124.418C68.9893 124.304 69.1378 124.247 69.313 124.247C69.4957 124.247 69.6442 124.3 69.7585 124.407C69.8727 124.513 69.9298 124.673 69.9298 124.886C69.9298 125.092 69.8689 125.252 69.747 125.366C69.6252 125.473 69.4767 125.526 69.3015 125.526Z",
    fill: "url(#paint4_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4678 126.828L76.8552 126.748V127.251L76.0784 127.479L76.2383 127.308L74.2508 132.848H73.177L71.3608 127.331L71.5207 127.479L70.7325 127.319V126.828L73.2456 126.748V127.251L72.2061 127.445L72.2975 127.308L73.8281 132.265H73.7367L75.3931 127.342L75.4616 127.445L74.4678 127.319V126.828Z",
    fill: "url(#paint5_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7192 132.311L81.5707 132.106L82.6216 132.311V132.814L81.0224 132.882L80.8853 131.786L80.9653 131.82C80.6302 132.186 80.2685 132.463 79.8801 132.654C79.4917 132.837 79.1148 132.928 78.7492 132.928C78.3075 132.928 77.9344 132.787 77.6298 132.505C77.3252 132.224 77.1729 131.797 77.1729 131.226C77.1729 130.777 77.2681 130.434 77.4584 130.198C77.6488 129.954 77.9116 129.783 78.2466 129.684C78.5817 129.585 78.9701 129.535 79.4118 129.535H80.9081L80.8053 129.65V128.553C80.8053 128.134 80.6949 127.837 80.4741 127.662C80.2532 127.479 79.9486 127.388 79.5602 127.388C79.3546 127.388 79.1338 127.411 78.8977 127.456C78.6693 127.495 78.4256 127.559 78.1667 127.651L78.3037 127.502L78.1895 128.542H77.5841L77.4927 127.125C77.9268 126.981 78.3342 126.874 78.715 126.805C79.0957 126.729 79.446 126.691 79.7659 126.691C80.3751 126.691 80.851 126.828 81.1937 127.102C81.544 127.369 81.7192 127.799 81.7192 128.393V132.311ZM78.0981 131.146C78.0981 131.519 78.1857 131.793 78.3609 131.968C78.5436 132.144 78.7721 132.231 79.0462 132.231C79.3128 132.231 79.6059 132.151 79.9258 131.991C80.2532 131.824 80.5693 131.599 80.8739 131.317L80.8053 131.557V130.027L80.9081 130.129H79.5488C79.0081 130.129 78.6312 130.213 78.418 130.381C78.2047 130.541 78.0981 130.796 78.0981 131.146Z",
    fill: "url(#paint6_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2931 132.928C84.8971 132.928 84.5849 132.806 84.3564 132.562C84.128 132.311 84.0137 131.934 84.0137 131.432V127.285L84.1622 127.434H82.9857V126.931L84.1737 126.76L84.0137 126.942V125.435L84.9276 125.286V126.942L84.8019 126.794H86.5953L86.561 127.434H84.8019L84.9276 127.285V131.306C84.9276 131.626 84.9885 131.858 85.1103 132.003C85.2398 132.147 85.4187 132.22 85.6472 132.22C85.7843 132.22 85.9328 132.197 86.0927 132.151C86.2526 132.106 86.424 132.041 86.6067 131.957L86.8009 132.483C86.2602 132.78 85.7576 132.928 85.2931 132.928Z",
    fill: "url(#paint7_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2146 132.243L89.1118 132.117L90.1056 132.334V132.825H87.4098V132.334L88.4036 132.117L88.3008 132.243V127.422L88.3922 127.525L87.4098 127.319V126.828L89.2146 126.76V132.243ZM88.6892 125.526C88.514 125.526 88.3693 125.469 88.2551 125.355C88.1409 125.24 88.0837 125.084 88.0837 124.886C88.0837 124.681 88.1409 124.525 88.2551 124.418C88.3769 124.304 88.5254 124.247 88.7006 124.247C88.8833 124.247 89.0318 124.3 89.1461 124.407C89.2603 124.513 89.3174 124.673 89.3174 124.886C89.3174 125.092 89.2565 125.252 89.1346 125.366C89.0128 125.473 88.8643 125.526 88.6892 125.526Z",
    fill: "url(#paint8_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7364 126.691C94.574 126.691 95.229 126.954 95.7011 127.479C96.1809 128.005 96.4207 128.747 96.4207 129.707C96.4207 130.354 96.3027 130.921 96.0666 131.409C95.8382 131.889 95.5107 132.262 95.0843 132.528C94.6578 132.795 94.1438 132.928 93.5422 132.928C92.7197 132.928 92.0762 132.673 91.6117 132.163C91.1472 131.645 90.9149 130.902 90.9149 129.935C90.9149 129.265 91.0253 128.69 91.2462 128.21C91.4746 127.723 91.7983 127.35 92.2171 127.091C92.6436 126.824 93.15 126.691 93.7364 126.691ZM93.6907 127.365C93.1043 127.365 92.655 127.586 92.3428 128.028C92.0306 128.469 91.8744 129.09 91.8744 129.89C91.8744 130.674 92.0229 131.264 92.3199 131.66C92.6169 132.056 93.0434 132.254 93.5993 132.254C94.0029 132.254 94.3418 132.155 94.6159 131.957C94.8977 131.751 95.1071 131.462 95.2442 131.089C95.3889 130.716 95.4612 130.27 95.4612 129.752C95.4612 128.976 95.3051 128.386 94.9929 127.982C94.6883 127.571 94.2542 127.365 93.6907 127.365Z",
    fill: "url(#paint9_linear_402_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3825 132.825V132.334L98.4105 132.106L98.2735 132.277V127.365L98.4105 127.536L97.3825 127.319V126.828L98.9817 126.748L99.1073 127.868L98.9817 127.822C99.3624 127.434 99.7584 127.148 100.17 126.965C100.589 126.783 100.984 126.691 101.358 126.691C101.86 126.691 102.275 126.847 102.603 127.159C102.938 127.464 103.102 127.94 103.094 128.587V132.277L102.98 132.117L103.985 132.334V132.825H101.323V132.334L102.317 132.117L102.18 132.288V128.782C102.18 128.309 102.073 127.963 101.86 127.742C101.647 127.521 101.361 127.411 101.004 127.411C100.722 127.411 100.413 127.487 100.078 127.639C99.7508 127.792 99.4272 128.028 99.1073 128.347L99.1873 128.165V132.288L99.0731 132.128L100.044 132.334V132.825H97.3825Z",
    fill: "url(#paint10_linear_402_592)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_402_592)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0756 73.7015C65.0756 73.7015 67.982 72.7883 71.2703 72.7883C74.5586 72.7883 75.318 71.0816 74.457 69.7501C73.5959 68.4186 69.945 62.1992 74.0905 60.3441C78.236 58.489 79.7107 58.4998 81.1224 60.712C82.5341 62.9241 80.3533 69.1476 80.7378 70.5339C81.1224 71.9202 81.8722 71.9234 81.8722 71.9234C81.8722 71.9234 86.5408 68.4005 89.9024 70.1619C89.9024 70.1619 91.8058 67.467 95.0077 68.7763C95.0077 68.7763 95.1238 63.1419 93.8551 62.4817C93.8551 62.4817 90.4229 65.1771 89.3808 63.9064C88.3387 62.6357 89.5382 60.0728 92.1011 60.0728C94.664 60.0728 95.3073 59.8958 95.3073 59.8958C95.3073 59.8958 102.601 68.2341 102.601 69.7878C102.601 71.3414 101.236 74.2178 99.4846 74.6746C99.4846 74.6746 94.5788 78.2311 91.0865 77.5477C91.0865 77.5477 90.4391 86.7931 83.3061 91.2056C83.3061 91.2056 81.5562 94.5142 82.5377 96.4002C82.5377 96.4002 76.3765 99.9762 69.7341 96.9735C69.7341 96.9735 71.9549 92.2091 70.7112 89.4721C70.7112 89.4721 65.8454 85.2832 66.2283 81.2125C66.2283 81.2125 62.0229 83.3926 57.6947 80.5079C57.6947 80.5079 54.6195 80.5214 53.646 79.059C53.646 79.059 53.6651 72.8366 55.1567 70.3099C55.1567 70.3099 55.6387 66.1033 56.8831 65.3231C56.8831 65.3231 62.8227 62.4723 63.9548 64.9009C63.9548 64.9009 64.8332 67.7233 60.0172 67.6688C60.0172 67.6688 59.0692 69.9024 59.5752 71.0942L60.2004 73.8553C60.2004 73.8553 61.6825 73.238 62.4693 73.2132C63.256 73.1883 65.0756 73.7015 65.0756 73.7015Z",
    fill: "url(#paint11_linear_402_592)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_402_592",
    x: 0.612305,
    y: 0.253479,
    width: 155.024,
    height: 171.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_402_592",
    x: 14.8184,
    y: 94.8736,
    width: 121.803,
    height: 73.9548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_402_592",
    x: 21.0093,
    y: 29.6265,
    width: 114.229,
    height: 104.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.333333 0 0 0 0 0.427451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_592",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_592",
    x1: 78.1245,
    y1: 32.8902,
    x2: 78.1245,
    y2: 138.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#2C2C2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_402_592",
    x1: 32.5669,
    y1: 135.825,
    x2: 118.59,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_402_592",
    x1: 78.1235,
    y1: 58.9995,
    x2: 78.1235,
    y2: 98.1741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C84D63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivation);
export default __webpack_public_path__ + "static/media/motivation.048f2126ffe593afd75f6572e6165778.svg";
export { ForwardRef as ReactComponent };